var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuillInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.75H10V14.375H10.625M18.125 10C18.125 12.1549 17.269 14.2215 15.7452 15.7452C14.2215 17.269 12.1549 18.125 10 18.125C7.84512 18.125 5.77849 17.269 4.25476 15.7452C2.73102 14.2215 1.875 12.1549 1.875 10C1.875 7.84512 2.73102 5.77849 4.25476 4.25476C5.77849 2.73102 7.84512 1.875 10 1.875C12.1549 1.875 14.2215 2.73102 15.7452 4.25476C17.269 5.77849 18.125 7.84512 18.125 10Z",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5.9375C10.625 6.10326 10.5592 6.26223 10.4419 6.37944C10.3247 6.49665 10.1658 6.5625 10 6.5625C9.83424 6.5625 9.67527 6.49665 9.55806 6.37944C9.44085 6.26223 9.375 6.10326 9.375 5.9375C9.375 5.77174 9.44085 5.61277 9.55806 5.49556C9.67527 5.37835 9.83424 5.3125 10 5.3125C10.1658 5.3125 10.3247 5.37835 10.4419 5.49556C10.5592 5.61277 10.625 5.77174 10.625 5.9375Z",
    fill: "#4E4E4E",
    stroke: "#4E4E4E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuillInfo);
export default __webpack_public_path__ + "static/media/quill_info.9dd52a54186708b593fd42aca05b6219.svg";
export { ForwardRef as ReactComponent };